export function triggerLoadBuildActionByAvis(trigger){
    return async function(dispatch){
        const action = { type : 'TRIGGER_LOADBUILD_AVIS', payload : trigger}
        dispatch(action);
    }
}

